<template>
  <div>
    <form @submit.prevent="submit">
      <!-- Nome -->
      <div class="campo">
        <label>*Nome:</label>
        <input
          v-model="form.nome"
          type="text"
          required="required"
          placeholder="Ex: RANCHO DO PEIXE"
        />
      </div>

      <!-- Descrição -->
      <div class="campo">
        <label>*Descrição:</label>
        <textarea
          v-model="form.descricao"
          rows="6"
          required="required"
          placeholder="Ex: Rancho do Peixe, localizado na Praia do Preá..."
        ></textarea>
      </div>

      <div class="campo">
        <label>*Descrição EN:</label>
        <textarea
          v-model="form.descricao_en"
          rows="6"
          required="required"
          placeholder="Ex: Rancho do Peixe, located on Preá Beach, is a rustic yet refined..."
        ></textarea>
      </div>

      <hr class="my-4" />
      <div class="linha-dupla">
        <div class="campo">
          <label>*Lista</label>
          <select v-model="form.lista" required="required">
            <option value="">Selecione...</option>
            <option
              v-for="lista in listaOpcoes"
              :key="lista.id"
              :value="lista.nome"
            >
              {{ lista.nome }}
            </option>
          </select>
        </div>

        <div class="campo">
          <label>*Local</label>
          <input
            v-model="form.local"
            type="text"
            required="required"
            placeholder="Ex: Preá (CE)"
          />
        </div>
      </div>

      <hr class="my-4" />
      <div class="linha-dupla">
        <div class="campo">
          <label>*E-mail:</label>
          <input
            v-model="form.email"
            type="text"
            required="required"
            placeholder="Ex: contato@ranchodopeixe.com"
          />
        </div>

        <div class="campo">
          <label>WhatsApp:</label>
          <input
            v-model="form.telefone"
            type="text"
            required="required"
            placeholder="Ex: 11986294355 "
          />
        </div>
      </div>

      <div class="campo">
        <label>*Site:</label>
        <input
          v-model="form.site"
          type="text"
          placeholder="Ex: https://ranchodopeixe.com.br"
          required="required"
        />
      </div>

      <!-- Redes sociais -->
      <hr class="my-4" />
      <div class="campo">
        <h3 class="mb-2">*Redes Sociais</h3>

        <div
          class="rede-item"
          v-for="(social, index) in form.redes"
          :key="index"
        >
          <div class="linha-dupla">
            <div class="campo">
              <label>Nome:</label>
              <select v-model="social.nome">
                <option value="" selected aria-selected="selected">
                  Selecione...
                </option>
                <option
                  v-for="rede in nomeRedesSociais"
                  :key="rede.id"
                  :value="rede.nome"
                >
                  {{ rede.nome }}
                </option>
              </select>
            </div>

            <div class="campo">
              <label>Endereço:</label>
              <input
                v-model="social.endereco"
                type="text"
                required="required"
                placeholder="Ex: @egroup"
              />
            </div>
          </div>

          <button class="btn-remover-img" @click.prevent="removerRede(index)">
            Remover Rede
          </button>
        </div>

        <button class="btn-save mt-2" @click.prevent="adicionarRede">
          + Adicionar Rede Social
        </button>
      </div>

      <!-- Upload -->
      <hr class="my-4" />
      <div class="campo">
        <h3 class="mb-2">*Adicionar novas imagens:</h3>

        <div
          class="dropzone"
          @dragover.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="dropFiles"
          @click="openFileDialog"
        >
          <p v-if="!isDragging">Clique ou arraste imagens aqui</p>
          <p v-else>Solte para enviar...</p>
          <p>Tamanho máximo 5 MB</p>

          <input
            ref="fileInput"
            type="file"
            multiple
            class="hidden-input"
            @change="handleFileUpload"
          />
        </div>
      </div>

      <!-- Preview -->
      <div v-if="form.novasImagens.length" class="lista-imagens mt-2">
        <div
          class="imagem-item"
          v-for="(file, index) in form.novasImagens"
          :key="index"
        >
          <img :src="file.preview" class="thumb" />
          <span class="text-xs text-gray-600">{{ file.name }}</span>

          <button
            class="btn-remover-img"
            @click.prevent="removerNovaImagem(index)"
          >
            Remover
          </button>
        </div>
      </div>

      <!-- Avisos -->
      <div class="form-hint">
        <div class="form-hint-main">
          <span class="asterisk">*</span>
          <span>Campos obrigatórios</span>
        </div>

        <div class="form-hint-note">
          <strong>Site:</strong>
          informe a URL completa, por exemplo
          <code>https://google.com</code>
        </div>
      </div>

      <div class="flex justify-end">
        <button
          type="submit"
          class="btn-save"
          :class="{ 'btn-desativado': loading }"
          :disabled="loading"
        >
          {{ loading ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { api } from '@/services/services';

export default {
  name: 'AddParceiro',

  data() {
    return {
      isDragging: false,
      form: {
        nome: '',
        descricao: '',
        descricao_en: '',
        email: '',
        telefone: '',
        site: '',
        lista: '',
        local: '',
        status: true,
        redes: [],
        novasImagens: [],
      },
      nomeRedesSociais: [
        {
          id: '1',
          nome: 'Instagram',
        },
        {
          id: '2',
          nome: 'Facebook',
        },
        {
          id: '3',
          nome: 'Youtube',
        },
        {
          id: '4',
          nome: 'Linkedin',
        },
      ],
      listaOpcoes: [
        {
          id: '1',
          nome: 'Terra do Vento',
        },
        {
          id: '2',
          nome: 'Outros / Brasil',
        },
        {
          id: '3',
          nome: 'América Latina',
        },
        {
          id: '4',
          nome: 'Mundo',
        },
      ],
      loading: false,
    };
  },

  methods: {
    processFiles(files) {
      const LIMITE = 5;

      files.forEach((file) => {
        if (this.form.novasImagens.length >= LIMITE) return;

        const jaExiste = this.form.novasImagens.some(
          (img) => img.name === file.name && img.size === file.size
        );

        if (jaExiste) return;

        file.preview = URL.createObjectURL(file);

        this.form.novasImagens.push(file);
      });
    },
    adicionarRede() {
      this.form.redes.push({
        nome: '',
        endereco: '',
      });
    },

    removerRede(index) {
      this.form.redes.splice(index, 1);
    },
    removerNovaImagem(index) {
      const file = this.form.novasImagens[index];

      // libera memória do preview
      if (file.preview) {
        URL.revokeObjectURL(file.preview);
      }

      this.form.novasImagens.splice(index, 1);
    },
    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      this.processFiles(files);
      event.target.value = '';
    },

    dropFiles(event) {
      this.isDragging = false;
      const files = Array.from(event.dataTransfer.files);
      this.processFiles(files);
    },

    openFileDialog() {
      this.$refs.fileInput.click();
    },

    async submit() {
      if (this.loading) return;
      this.loading = true;

      const formData = new FormData();

      formData.append('nome', this.form.nome);
      formData.append('descricao', this.form.descricao);
      formData.append('descricao_en', this.form.descricao_en);
      formData.append('email', this.form.email);
      formData.append('telefone', this.form.telefone);
      formData.append('site', this.form.site);
      formData.append('lista', this.form.lista);
      formData.append('local', this.form.local);
      formData.append('status', 1);

      formData.append('responsavel_created', this.usuario.nome);

      this.form.redes.forEach((rede, index) => {
        formData.append(`redes[${index}][nome]`, rede.nome);
        formData.append(`redes[${index}][endereco]`, rede.endereco);
      });

      this.form.novasImagens.forEach((file) =>
        formData.append('novasImagens[]', file)
      );

      try {
        const response = await api.post('alliances/adiciona', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        this.$toast.success({
          title: 'Sucesso',
          message:
            response.data?.message || 'Atualização realizada com sucesso!',
          position: 'bottomRight',
        });

        this.$store.dispatch('fetchAlliances');
        this.$router.push({ name: 'admin' });
      } catch (error) {
        const msg = error.response.data.error;
        this.$toast.error({
          title: 'Erro',
          message: msg || 'Falha ao tentar atualizar o parceiro!',
          position: 'bottomRight',
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    },
  },
  beforeDestroy() {
    this.form.novasImagens.forEach((file) => {
      if (file.preview) {
        URL.revokeObjectURL(file.preview);
      }
    });
  },
};
</script>

<style scoped>
.linha-tripla {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

button:disabled,
.btn-desativado {
  background: #ddd;
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none; /* segurança extra */
}

.linha-dupla {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

@media (max-width: 700px) {
  .linha-tripla,
  .linha-dupla {
    grid-template-columns: 1fr;
  }
}

.campo {
  margin-bottom: 15px;
}

input,
textarea,
select {
  padding: 10px 12px;
  width: 100%;
  box-sizing: border-box;
}

.lista-imagens {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.imagem-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.thumb {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
}

.btn-remover-img {
  background: #c33;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 0.75rem;
}

.btn-save {
  background: #008b23;
  color: white;
  padding: 8px 14px;
  border-radius: 4px;
}

.btn-cancel {
  background: #c33;
  color: white;
  padding: 8px 14px;
  border-radius: 4px;
  margin-left: 10px;
}

.botoes {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.campo-status {
  display: flex;
  align-items: center;
  gap: 15px;
}

.switch {
  position: relative;
  width: 46px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  inset: 0;
  background-color: #ccc;
  border-radius: 34px;
  transition: 0.3s;
}

.slider:before {
  content: '';
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
  transition: 0.3s;
}

input:checked + .slider {
  background: #4a4a4a;
}

input:checked + .slider:before {
  transform: translateX(22px);
}

input,
select,
textarea {
  width: 100%;
  padding: 10px 20px;
  border: 1px solid #b8b8b8;
  border-radius: 4px;
}

.form-hint {
  font-size: 0.85rem;
  color: #6c757d;
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 32px;
}

.form-hint-main {
  display: flex;
  align-items: center;
  gap: 4px;
}

.form-hint .asterisk {
  color: #dc3545;
  font-weight: bold;
}

.form-hint-note {
  font-size: 0.8rem;
  color: #555;
  padding-left: 14px;
  border-left: 2px solid #e0e0e0;
}

.form-hint-note code {
  background: #f1f1f1;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.78rem;
}

.dropzone {
  border: 2px dashed #999;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: 0.3s;
  color: #555;
}

.dropzone:hover {
  border-color: #666;
  background: #f8f8f8;
}

.dropzone.drag-active,
.dropzone:active {
  border-color: #008b23;
  background: #e8ffe8;
}

.hidden-input {
  display: none;
}

@media (max-width: 640px) {
  /* grids viram coluna */
  .linha-dupla,
  .linha-tripla {
    grid-template-columns: 1fr;
  }

  /* botões em coluna */
  .botoes {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-save,
  .btn-remover-img {
    width: 100%;
    text-align: center;
  }

  /* dropzone mais compacta */
  .dropzone {
    padding: 20px;
    font-size: 0.85rem;
  }

  /* thumbs menores */
  .thumb {
    width: 64px;
    height: 64px;
  }

  /* labels e inputs mais confortáveis */
  label {
    font-size: 0.85rem;
  }

  input,
  textarea,
  select {
    font-size: 0.9rem;
  }
}
@media (min-width: 641px) and (max-width: 1023px) {
  /* mantém duas colunas */
  .linha-dupla {
    grid-template-columns: repeat(2, 1fr);
  }

  /* espaçamento melhor entre ações */
  .botoes {
    justify-content: flex-end;
  }

  .dropzone {
    padding: 25px;
  }

  .thumb {
    width: 72px;
    height: 72px;
  }
}
</style>
